<ag-shr-modal-window
  #promptModalRef
  [title]="title"
  [width]="'420px'"
  [height]="'auto'"
  [actionTitle]="actionTitle"
  (onSaveClick)="onApplyClick()"
  [showCancelButton]="false"
  [showCloseButton]="false"
  [closeOnEscapeButton]="false"
  [extraToolbarItems]="[
    {
      widget: 'dxButton',
      location: 'after',
      toolbar: 'bottom',
      options: {
        text: 'CANCEL',

        onClick: onAbortClick,
        elementAttr: {
          class: 'modal-window__toolbar-button 1',
        },
      },
    },
  ]"
>
  <ng-content></ng-content>
</ag-shr-modal-window>
